import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

function CallUs() {
  return (
    <>
      <div className="flex flex-col container max-w-7xl mx-auto mt-20">
        <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
          لديك استفسار؟
        </div>
        <div className="self-center mt-8 w-full max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
            <div className="flex flex-col ml-5 w-[58%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow p-8 w-full text-base font-medium leading-5 text-red-600 bg-white rounded-xl border border-solid border-neutral-200 max-md:px-5 max-md:mt-5 max-md:max-w-full">
                <div className="text-xl font-bold text-right text-black max-md:max-w-full">
                  نموذج الاتصال
                </div>
                <div className="self-start mt-5 whitespace-nowrap">
                  نص الرسالة<span className="text-red-600"> *</span>
                </div>
                <textarea
                  className="outline-none resize-none justify-start items-end pt-2.5 pr-3.5 pb-72 pl-16 mt-1.5 text-sm leading-5 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-stone-300 max-md:pb-10 max-md:pl-5 max-md:max-w-full"
                  placeholder="يرجى كتابة نص الرسالة هنا"
                />

                <div className="self-start mt-5 whitespace-nowrap">
                  الاسم<span className="text-red-600"> *</span>
                </div>
                <input
                  className="outline-none justify-center items-start py-2.5 pr-3.5 pl-16 mt-1.5 text-sm leading-5 text-right whitespace-nowrap bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-stone-300 max-md:pl-5 max-md:max-w-full"
                  placeholder="اكتب الاسم هنا"
                />

                <div className="self-start mt-5 whitespace-nowrap">
                  البريد الالكتروني <span className="text-red-600"> *</span>
                </div>
                <input
                  className="outline-none justify-center items-start py-2.5 pr-3.5 pl-16 mt-1.5 text-sm leading-5 text-right whitespace-nowrap bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-stone-300 max-md:pl-5 max-md:max-w-full"
                  placeholder="البريد الاكتروني هنا"
                />
                <button className="justify-center self-start px-5 py-2.5 mt-5 text-base font-bold text-center text-white whitespace-nowrap bg-blue-900 rounded-lg shadow-sm aspect-[1.63]">
                  ارسال
                </button>
              </div>
            </div>
            <div className="flex flex-col w-[42%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col max-md:mt-5 max-md:max-w-full">
                <div className="flex flex-col justify-center px-5 py-8 rounded-xl border border-solid backdrop-blur-[10px] bg-zinc-50 border-zinc-300 max-md:max-w-full">
                  <div className="flex flex-col pl-20 max-md:pl-5 max-md:max-w-full">
                    <div className="self-start text-xl font-bold text-right text-black whitespace-nowrap">
                      حساباتنا على الشبكات الاجتماعية
                    </div>
                    <div className="flex gap-5 justify-between mt-5 ml-3 max-md:ml-2.5">
                      <LazyLoadImage
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/c0eaf63cf792f86db3a53d32546d1df37c3bda2a61fb19510926918d6915a66d?"
                        className="w-9 aspect-square"
                      />
                      <LazyLoadImage
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/1f1ca8b4bf90319aaa5a8f914faab369142b72d5563034c932c80de954cb216b?"
                        className="aspect-[0.97] w-[35px]"
                      />
                      <LazyLoadImage
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/24949518c4ceb0472bdf1380b0a398eff2a9cd7a1a16da66faa3367d635cf37b?"
                        className="w-9 aspect-square"
                      />
                      <LazyLoadImage
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/bfbd63c8c24df872a35d5ddc5115d9af948de6100506a3dfad048283e9e46164?"
                        className="my-auto aspect-square w-[30px]"
                      />
                      <LazyLoadImage
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/53496a5240b8945cb85101ab427be4ca3190a567f7a9a463621d956b76ad15e6?"
                        className="w-9 aspect-square"
                      />
                      <LazyLoadImage
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/f504c56b3bd7ae62d44be08d874d1b693e553ad5dff0ca8f6f7079a0f0d70efd?"
                        className="w-9 aspect-square"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col justify-center px-5 py-8 mt-5 text-xl font-bold text-right text-black rounded-xl border border-solid backdrop-blur-[10px] bg-zinc-50 border-zinc-300 max-md:max-w-full">
                  <div className="flex gap-5 justify-between max-md:flex-wrap max-md:max-w-full">
                    <div>
                      <span className="leading-6">تواصل معنا عبر </span>
                      <br />
                      <span className="text-4xl leading-10">Whatsapp</span>
                    </div>
                    <LazyLoadImage
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/03ffb6bfa8845e1ece927c7f3ed04ec7434a9085b1a1f534a0a4314f9aebbd32?"
                      className="self-start aspect-square w-[72px]"
                    />
                  </div>
                </div>
                <div className="flex flex-col justify-center px-5 py-8 mt-5 text-black rounded-xl border border-solid backdrop-blur-[10px] bg-zinc-50 border-zinc-300 max-md:max-w-full">
                  <div className="flex flex-col self-start w-32 max-w-full text-xl font-bold text-right whitespace-nowrap">
                    <LazyLoadImage
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/70d31fadb2387fc0784844081a35f3b9d3a679dd88ac7452aa426d1018b1d918?"
                      className="self-start w-9 aspect-square"
                    />
                    <div className="mt-2">البريد الالكتروني؟</div>
                  </div>
                  <div className="mt-2 text-base text-justify underline max-md:max-w-full">
                    أرسل لنا رسالة على{" "}
                    <a
                      href="mailto:info@alkhairmiddleeast.org"
                      className="font-semibold text-black underline"
                      target="_blank"
                    >
                      info@alkhairmiddleeast.org
                    </a>{" "}
                    <br />
                    أو استخدم نموذج الاتصال الموجود على اليمين!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <iframe
        style={{ width: "100%", height: 400, marginTop: 30 }}
        src="https://www.openstreetmap.org/export/embed.html?bbox=32.71179199218751%2C30.03105542654023%2C37.8533935546875%2C33.224903086263964&amp;layer=cyclosm"
      ></iframe>
    </>
  );
}

export default CallUs;
